module.exports = __webpack_public_path__ + "static/sport/bgi-pc.6482d0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/bgi-pc.jpg
// module id = wqC/
// module chunks = 0